// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ac3b255","453":"6f481718","455":"d622ac6d","977":"789d578a"}[chunkId] + ".chunk.js";
};